import { APP_NAME } from '@beatgig/constants'

export const sellerInviteOnlyText = `Thank you for signing up for ${APP_NAME}. Due to high demand, we're currently invite-only. You've been added to the waitlist.`
